import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-use-before-define */
var LOGIC_TYPE_CONDITION = 'condition';
var LOGIC_TYPE_SET = 'set';
var SET_VALUE_ANY = 'any';
var SET_VALUE_ALL = 'all';
function constructValidDefaultState(_ref) {
  var defaultValue = _ref.defaultValue,
    defaultSetValue = _ref.defaultSetValue,
    fixedSet = _ref.fixedSet,
    maxNestedSets = _ref.maxNestedSets;
  var clone;
  if (defaultValue) {
    clone = deepCopy(defaultValue);
  } else {
    clone = newConditionSet(defaultSetValue);
  }
  var internalMaxNestedSets = maxNestedSets;
  if (fixedSet) {
    internalMaxNestedSets = 0;
  }
  ensureFixedSetHasOneCondition(clone, fixedSet);
  pruneSets(clone, 0, internalMaxNestedSets);
  assignIdentifiersAndSetValues(clone, defaultSetValue);
  return clone;
}
function fixedSetHasNoConditions(defaultValue, fixedSet) {
  var _defaultValue$conditi;
  return fixedSet && defaultValue && (!(defaultValue !== null && defaultValue !== void 0 && defaultValue.conditions) || !((defaultValue === null || defaultValue === void 0 || (_defaultValue$conditi = defaultValue.conditions) === null || _defaultValue$conditi === void 0 ? void 0 : _defaultValue$conditi.length) >= 1));
}
function ensureFixedSetHasOneCondition(defaultValue, fixedSet) {
  if (fixedSetHasNoConditions(defaultValue, fixedSet)) {
    // eslint-disable-next-line no-param-reassign
    defaultValue.conditions = [newCondition()];
  }
}
function pruneSets(set, level, maxNestedSets) {
  if (level === maxNestedSets) {
    var _context;
    // eslint-disable-next-line no-param-reassign
    set.conditions = _filterInstanceProperty(_context = set.conditions).call(_context, function (condition) {
      return condition.logicType !== LOGIC_TYPE_SET;
    });
  } else {
    var _context2;
    _forEachInstanceProperty(_context2 = set.conditions).call(_context2, function (condition) {
      if (condition.logicType === LOGIC_TYPE_SET) {
        pruneSets(condition, level + 1, maxNestedSets);
      }
    });
  }
}
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    var r = Math.random() * 16 | 0;
    // eslint-disable-next-line no-bitwise
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
function deepCopy(object) {
  return JSON.parse(_JSON$stringify(object));
}
function shallowCopy(object) {
  return _objectSpread({}, object);
}
function newCondition() {
  return {
    id: uuidv4(),
    logicType: LOGIC_TYPE_CONDITION
  };
}
function newConditionSet(value) {
  return {
    id: uuidv4(),
    logicType: LOGIC_TYPE_SET,
    value: value,
    conditions: [newCondition()]
  };
}
function assignIdentifiersAndSetValues(tree, defaultSetValue) {
  var queue = [];
  queue.push(tree);
  while (queue.length > 0) {
    var node = queue.pop();
    if (!node.id) {
      node.id = uuidv4();
    }
    if (node.logicType === LOGIC_TYPE_SET && !node.value) {
      node.value = defaultSetValue;
    }
    if (node.conditions) {
      queue.push.apply(queue, _toConsumableArray(node.conditions));
    }
  }
  return tree;
}
function walkToRoot(position) {
  var root = {
    level: position.level,
    index: position.index
  };
  for (var current = position.parent; current; current = current.parent) {
    root = {
      level: current.level,
      index: current.index,
      child: _objectSpread({}, root)
    };
  }
  return root;
}
function getParentSet(conditionRoot, position) {
  var positionFromRoot = walkToRoot(position);
  var set = conditionRoot;
  for (var child = positionFromRoot.child; child && child.child; child = child.child) {
    set = set.conditions[child.index];
  }
  return set;
}

export { LOGIC_TYPE_CONDITION, LOGIC_TYPE_SET, SET_VALUE_ALL, SET_VALUE_ANY, assignIdentifiersAndSetValues, constructValidDefaultState, getParentSet, newCondition, newConditionSet, shallowCopy };
